import React, { useEffect, useContext } from "react";
import { LanguageContext } from "../context/LanguageProvider";

const styles = {
  background: {
    position: "fixed",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "25px",
    color: "black",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: "0px",
    right: "10px",
    cursor: "pointer",
    fontSize: "21px",
  },
  buttonsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "10px",
  },
  button: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "#ffffff",
    color: "black",
    border: "none",
    borderRadius: "5px",
    textAlign: "left",
    cursor: "pointer",
  },
  image: {
    width: "25px",
    height: "20px",
    marginRight: "8px",
  },
};

const languages = [
  { code: "en", name: "English", flag: "./img/usa.png" },
  { code: "es", name: "Spanish", flag: "./img/spain.png" },
  { code: "fr", name: "French", flag: "./img/france.png" },
  { code: "de", name: "German", flag: "./img/germany.png" },
  { code: "it", name: "Italian", flag: "./img/italy.png" },
  { code: "ja", name: "Japanese", flag: "./img/japan.png" },
  { code: "pt", name: "Portuguese", flag: "./img/brazil.png" },
  { code: "ru", name: "Russian", flag: "./img/russia.png" },
  { code: "nl", name: "Dutch", flag: "./img/netherlands.png" },
  { code: "zh", name: "Chinese", flag: "./img/china.png" }
];

export default function LanguageModal({ isOpen, setModalOpen }) {
  const { setLanguage } = useContext(LanguageContext);

  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => {
        setModalOpen(false);
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [isOpen, setModalOpen]);
  if (!isOpen) return null;

  return (
    <div style={styles.background}>
      <div style={styles.modal}>
        <div
          style={styles.closeButton}
          onClick={() => {
            setModalOpen(false);
          }}
        >
          x
        </div>
        <div style={styles.buttonsContainer}>
          {languages.map((language) => (
            <button
              key={language.code}
              style={styles.button}
              onClick={() => {
                setModalOpen(false);
                setLanguage(language.code);
                console.log(`Idioma selecionado: ${language.name}`);
              }}
            >
              <img
                src={language.flag}
                alt={`${language.name} Flag`}
                style={styles.image}
              />
              {language.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
